import request from '@/util/request';
// import qs from 'qs';

// 字典数据
export const getDict = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));
//项目列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));
//仓库列表
export const getWarehouseList = (params, options) =>
    request.get('/api/v4ward/warehouse/getWarehouseList', Object.assign({}, options, { params }));
//获取单号
export const getBusinessNo = (params, options) =>
    request.get('/api/v4ward/warehouse/common/getBusinessNo', Object.assign({}, options, { params }));
//新增入库
export const inboundSave = (params, options) =>
    request.post('/api/v4ward/warehouse/inbound/save', params, options);
//新增入库
export const inboundSubmit = (params, options) =>
    request.post('/api/v4ward/warehouse/inbound/submit', params, options);
//入库列表
export const inboundPage = (params, options) =>
    request.get('/api/v4ward/warehouse/inbound/page', Object.assign({}, options, { params }));
//入库单详情-基础信息
//id
export const inboundDetail = (params, options) =>
    request.get('/api/v4ward/warehouse/inbound/detail', Object.assign({}, options, { params }));
//入库单详情-货品列表
//inboundId
export const inboundDetailList = (params, options) =>
    request.get('/api/v4ward/warehouse/inbound/consumable/getConsumableListByInboundId', Object.assign({}, options, { params }));

//分类树-懒加载
export const typeLazyTree = (params, options) =>
    request.get('/api/v4ward/warehouse/consumable/type/lazyTree', Object.assign({}, options, { params }));//商品分类
//列表
export const consumableList = (params, options) =>
    request.get('/api/v4ward/warehouse/consumable/list', Object.assign({}, options, { params }));
//刷新库存
export const viewUpdateConsumableList = (data, options) =>
    request.post('/api/v4ward/warehouse/consumable/viewUpdateConsumableList',data,options);
//获取供应商列表
export const supplierList = (params, options) =>
    request.get('/api//v4ward/partner/supplierList',Object.assign({}, options, { params }));
